export * from './TaxProfile';
export {default as TaxProfile} from './TaxProfile';

export * from './TaxRecordProfile';
export {default as TaxRecordProfile} from './TaxRecordProfile';

export * from './TaxProfileInterviewInfo';
export {default as TaxProfileInterviewInfo} from './TaxProfileInterviewInfo';

export * from './TaxRecordDialog';
export {default as TaxRecordDialog} from './TaxRecordDialog';

export * from './TaxProfileQA';
export {default as TaxProfileQA} from './TaxProfileQA';
